import { DialogTitle } from '@headlessui/react'
import PropTypes from 'prop-types'

import Button from './tailwind/Button'
import Modal from './tailwind/Modal'

const EmailVerificationRequiredModal = ({
  open,
  setOpen,
  title,
  description,
  closeText,
  verifyText,
  onVerify,
  size = 'lg'
}) => {
  return (
    <Modal open={open} setOpen={setOpen} size={size}>
      <DialogTitle className='mt-8 text-center text-2xl font-medium leading-6 text-gray-900'>
        {title}
      </DialogTitle>
      <span className='mx-auto mt-2 block max-w-sm text-center text-base text-gray-600'>
        {description}
      </span>
      <div className='mt-8 flex flex-row gap-3'>
        <Button.SecondaryXL
          fullWidth
          text={closeText}
          onClick={() => setOpen(false)}
        />
        <Button.PrimaryXL
          fullWidth
          text={verifyText}
          onClick={() => {
            setOpen(false)
            onVerify?.()
          }}
        />
      </div>
    </Modal>
  )
}

EmailVerificationRequiredModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  closeText: PropTypes.node.isRequired,
  verifyText: PropTypes.node.isRequired,
  onVerify: PropTypes.func,
  size: PropTypes.string
}

export default EmailVerificationRequiredModal
